import { withStyles, Container } from "@material-ui/core";
import React from "react";
import styles from "./styles";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";
import NewsItem from "../../NewsItem";
import TitlePage from '../../TitlePage';

class NewsHome extends React.Component {
  render() {
    const { classes, news } = this.props;

    const newsFiltered = news.filter(item => item.is_home === "1");

    const renderNewsHome = () => {
      if (newsFiltered && newsFiltered.length > 0) {
        return newsFiltered.map(item => <NewsItem item={item} key={item.id} />);
      }
    };

    const responsive = {
      0: {
        items: 1
      },
      450: {
        items: 2
      },
      960:{
        items: 3
      },
      1024: {
        items: 4
      }
    };

    return (
      <Container maxWidth="xl">
        <TitlePage 
          name="Tin tức nổi bật" 
          desc="Cập nhật những bài viết tin tức mới nhất" 
          style={{
            textAlign: 'center', 
            margin: '30px 0', 
            borderTop: '1px solid #e1e1e1',
            paddingTop: 30
          }} 
        />

        <div className={classes.container}>
          {newsFiltered && newsFiltered.length > 0 && (
            <>
              <AliceCarousel
                responsive={responsive}
                infinite
                autoPlay
                dotsDisabled
                buttonsDisabled
                autoPlayInterval={5000}
                stopAutoPlayOnHover
                ref={el => (this.Carousel = el)}
              >
                {renderNewsHome()}
              </AliceCarousel>
              <button
                className="button-left"
                onClick={() => this.Carousel.slidePrev()}
              >
                <FiChevronLeft />
              </button>
              <button
                className="button-right"
                onClick={() => this.Carousel.slideNext()}
              >
                <FiChevronRight />
              </button>
            </>
          )}
        </div>
      </Container>
    );
  }
}

export default withStyles(styles)(NewsHome);
